import React from 'react';
import Paper from '@material-ui/core/Paper';
import BCLButton from '../../../common/Buttons/BCLButton';
import { Configuration } from '../../../../configs/Configuration';
import { trackEvent } from '../../../../helpers/analyticsHelper';
import { PAGE_EVENT_NAMES, HOME_PAGE_WIDGETS, LEARN_MORE } from '../../../../constants/common';

export default class SmartRecommendation extends React.Component {
  constructor(props){
    super(props);
    this.configColors = Configuration.getColors().colors;
  }

  ctaClicked(){
    trackEvent(this.props.userId, PAGE_EVENT_NAMES.DASHBOARD, {
      widget : HOME_PAGE_WIDGETS.SMART_RECO,
      btnClicked : LEARN_MORE
    })
  }

  render(){
    let smartReco = this.props.smartRecommendationData.data;
    return(
      <>
        {
        smartReco.recoMeta &&
        <Paper className="smart_reco" onMouseOver={() => this.props.onHoverReco()}>
        <div className="smart-reco-container">
          <div className="offer">
            <div className="offer-image">
              <img src={smartReco.recoMeta.dashboardIcon} alt="smart_reco"/>
            </div>
            <div className="offer-container">
              <div className="offer-text">
                <div className="title">{smartReco.recoMeta.title}</div>
                <div className="sub-title">{smartReco.recoMeta.description}</div>
              </div>
              {
                smartReco.recoMeta.link && smartReco.recoMeta.callToAction &&
                <div className="offer-cta" onClick={()=> this.ctaClicked()}>
                  <a type="button" href={smartReco.recoMeta.link} target="_blank" className="reco-cta">{smartReco.recoMeta.callToAction}</a>
                </div>
              }
            </div>
          </div>
          {
            this.props.recoInsightEnabled && smartReco.recoInsight &&
            <div className="reco-insight-container">	
              <img src={this.props.configs["DASHBOARD.RECOMMENDATIONS.INSIGHTS_BULB"]} alt=""/>	
              <div className="insight">{smartReco.recoInsight.insightText}</div>	
            </div>	
          }	
        </div>	
      </Paper>	
      }
      </>
    );
  }
}
